import React, { useReducer, useEffect, useState } from "react"
import { getCountryCallingCode } from "react-phone-number-input"
import Layout from "../../../components/layout/layout"
import HowItWorks from "../../../components/cards/howitworks/HowItWorks"
import OurSolutions from "../../../components/solutions/Solutions"
import Clients from "../../../components/cards/clients"
import TestimonialSection from "../../../components/homepage/testimonials"
import Features from "../../../components/cards/features/Features"
import InquireSection from "../../../components/cards/inquire/InquireSection"
import OtherProducts from "../../../components/cards/relatedarticles/RelatedArticles"
import banner from "./banner.png"
import feature1 from "./feature-1.svg"
import feature2 from "./feature-2.png"
import feature3 from "./feature-3.png"
import feature4 from "./feature-4.svg"
import {
  otherProducts,
  productFaq,
  formatNumber,
  validateEmail,
} from "../../../utils"
import SEO from "../../../components/seo"
import { requestService } from "../../../services"
import SucessModal from "../../../components/modals/successModal/successModal"
import BookingSection from "../../../components/serviceCards/bookingSection/index.jsx"

const GlassX = ({ location: { pathname } }) => {
  const [details, setDetails] = useReducer(
    (state, newState) => ({
      ...state,
      ...newState,
    }),
    {
      phone: "",
      name: "",
      email: "",
      company: "",
      comments: "",
      designation: "",
      country_code: "+1",
      requesting: false,
      response: "",
      terms: false,
      submitted: false,
    }
  )
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  useEffect(() => {
    let timeout
    if (details.response) {
      setShowSuccessModal(true)
      timeout = setTimeout(() => {
        setShowSuccessModal(false)
        setDetails({ response: "" })
      }, 5000)
    }
    return () => {
      clearTimeout(timeout)
    }
  }, [details.response])
  const data = {
    title:
      "Drive seamless \ncommunication across teams and accomplish project objectives efficiently",
    bannerImage: banner,
    desc:
      "Use the power of data for empowered project management and workflows",
    overview: "GlassX Overview",
    overviewText:
      "Wersel’s GlassX is a cross-functional collaboration tool that enables people from different functional areas of the organization to come up together to work on a common project. In many cases, people from the finance, marketing, and human resources department come up together to work on solving a specific problem. This cross-functional collaboration tool enhances teamwork and suggests better ways to establish a greater level of communication among all the people that will lead to continuous improvement from everyone. With the Wersel’s GlassX product, it would be an effortless task for you to keep your entire team updated about the work progress. As mentioned GlassX brings the different skills together to a group, which means they have opportunities to learn new skills from one another.",
    features: [
      {
        title: "VERSATILITY",
        description:
          "Attach files from computer storage plus popular cloud services such as \nGoogle Drive, Dropbox, and OneDrive.",
        featureImage: feature1,
        imagePosition: "right",
      },
      {
        title: "Smart \nMarkdown",
        description:
          "Markdown helps to create a more organized description for cards by adding \nheadings, bulletin points, and styles to your simple text formats.",
        featureImage: feature2,
        imagePosition: "left",
        hack: "w-378",
      },
      {
        title: "Power packed filter & \nsearch",
        description:
          "To make your cards more accessible, you can add labels to them that can be \nused for filter and search.",
        featureImage: feature3,
        imagePosition: "right",
        hack: "w-378",
      },
      {
        title: "100% Ease \nof Use",
        description:
          "Easy way to add cards from dashboards, graphs, and data sources.",
        featureImage: feature4,
        imagePosition: "left",
      },
    ],
    subSectionTitle: "Explore GlassX",
    platformText:
      "Executing projects becomes productive and removes silos. Explore GlassX in action!",
  }
  const handleNumberSelect = value => {
    setDetails({ phone: value })
  }
  const getCountryCode = value => {
    let countryCode = value && getCountryCallingCode(value)
    setDetails({ country_code: `+${countryCode}` })
  }
  const onChange = e => {
    const { name, value } = e.target
    setDetails({ [name]: value })
  }
  const onCheck = e => {
    setDetails({ terms: e.target.checked })
  }
  const submit = async () => {
    setDetails({ submitted: true })
    const {
      name,
      phone,
      email,
      company,
      comments,
      designation,
      country_code,
      terms,
    } = details
    let data
    if (
      name !== "" &&
      phone !== "" &&
      email !== "" &&
      company !== "" &&
      comments !== "" &&
      designation !== "" &&
      validateEmail(email)
    ) {
      if (!terms) {
        alert("please accept our terms and conditions")
        return
      }
      let number = formatNumber(phone)
      data = {
        form_name: "contact form",
        page_url: pathname,
        section_name: "glassx",
        name,
        company_name: company,
        designation,
        email,
        country_code,
        phone_number: number,
        your_message: comments,
      }
      try {
        setDetails({ requesting: true })
        let result = await requestService.productForm(data)
        setDetails({
          phone: "",
          name: "",
          email: "",
          company: "",
          comments: "",
          designation: "",
          country_code: "",
          requesting: false,
          terms: false,
          response: result && result.more_info,
          submitted: false,
        })
      } catch (err) {
        console.log(err)
        setDetails({ requesting: false })
      }
    }
  }
  return (
    <Layout withBrand slidePosition={0} btnBg="#204B9B" btnColor="#FFFFFF">
      {showSuccessModal && <SucessModal show={showSuccessModal} />}
      <SEO
        title="Wersel GlassX - Plan, Track, Release And Report With Data In Your Hand "
        keywords="wersel glassx, team collaboration software, collaboration platform, enterprise collaboration software, online collaboration platforms "
        description="Wersel’s GlassX is a cross-functional collaboration tool that enables people from different functional areas of the organization to come up together to work on a common project."
        url="www.wersel.io/products/glassx"
      />
      <OurSolutions data={data} btnBg="#204B9B" btnColor="#FFFFFF" />
      <Features title="GlassX Features" features={data.features} />
      <BookingSection
        howItWorksTitle="Plan, Track, Release And Report With Data In Your Hand"
        howItWorks="Check out the ways you can get an unbeatable competitive upper hand with GlassX"
      />
      <Clients title="We gave solutions for" />
      <InquireSection
        withoutFaqText
        btnBg="#204B9B"
        btnColor="#FFFFFF"
        faq={productFaq}
        handleNumberSelect={handleNumberSelect}
        getCountryCode={getCountryCode}
        details={details}
        onChange={onChange}
        submit={submit}
        onCheck={onCheck}
      />
      {/* <TestimonialSection /> */}
      <OtherProducts path={pathname} title="Products" posts={otherProducts} />
    </Layout>
  )
}

export default GlassX
